var _style, _defs, _defs2, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconsPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.2 13.2",
    style: {
      enableBackground: "new 0 0 13.2 13.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#405C40;}\r\n\t.st1{clip-path:url(#SVGID_00000013913533245053849290000002743871598241279144_);fill:#405C40;}\r\n\t.st2{clip-path:url(#SVGID_00000114769470787382627690000008889126212684922781_);fill:#405C40;}\r\n\t.st3{clip-path:url(#SVGID_00000049910536757283009430000008761986057007009693_);fill:#405C40;}\r\n\t.st4{clip-path:url(#SVGID_00000032647449845323291600000003260975664623061130_);fill:#405C40;}\r\n\t.st5{clip-path:url(#SVGID_00000124137435873327305360000011282481558431104898_);fill:#405C40;}\r\n\t.st6{fill:#CD2D40;}\r\n\t.st7{fill:#0D468F;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173144674177805724120000004005293572484619658_",
    width: 13.2,
    height: 13.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127723087397035605660000012849649748375679898_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173144674177805724120000004005293572484619658_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000127723087397035605660000012849649748375679898_)",
      fill: "#405C40"
    },
    d: "M4.9,4.7 c0.1-0.1,0.3-0.4,0.4-0.6c0.3-0.8,0.2-1,0.2-1C5.3,2.6,4.8,2,4.2,1.4C3.6,0.7,3,0.3,2.5,0c0,0-0.8-0.2-1.3,0.3c0,0,0,0,0,0 c0,0,0,0,0,0l0,0C1.1,0.5,1,0.6,0.9,0.6L4.9,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111181791736878479760000002527787398938692267_",
    width: 13.2,
    height: 13.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165929856169846645780000010084383048935738039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111181791736878479760000002527787398938692267_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000165929856169846645780000010084383048935738039_)",
      fill: "#405C40"
    },
    d: "M13.1,10.7 c-0.2-0.5-0.7-1.1-1.3-1.7c-0.6-0.6-1.3-1.1-1.7-1.3c0,0-0.2-0.2-1,0.2C8.9,7.9,8.6,8.1,8.5,8.2l4,4c0.1-0.1,0.2-0.1,0.2-0.2h0 c0,0,0,0,0,0c0,0,0,0,0,0C13.3,11.4,13.1,10.7,13.1,10.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119830760056400389140000005693794182178638260_",
    width: 13.2,
    height: 13.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008870618763278826970000002545076899520745884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119830760056400389140000005693794182178638260_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000008870618763278826970000002545076899520745884_)",
      fill: "#405C40"
    },
    d: "M8.1,8.8 C8,9,7.8,9,7.5,9C6.8,9,5.7,8.4,5.2,7.9C4.6,7.3,3.7,5.6,4.4,5.1c0,0,0.1,0,0.1-0.1L0.6,1.1C0,2,0,2.7,0,2.7S-0.1,6,3.6,9.6 c3.5,3.5,6.6,3.6,6.9,3.6h0h0c0.1,0,0.8,0,1.6-0.6L8.2,8.7C8.1,8.7,8.1,8.8,8.1,8.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconsPhone);
export default __webpack_public_path__ + "static/media/InfoIcons_Phone.9d1830311425e70e78b91d546c8d7ad6.svg";
export { ForwardRef as ReactComponent };